import script from "./SensorTypesManager.vue?vue&type=script&setup=true&lang=js"
export * from "./SensorTypesManager.vue?vue&type=script&setup=true&lang=js"

import "./SensorTypesManager.vue?vue&type=style&index=0&id=08d3937c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d3937c"]])

export default __exports__